import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const AgencyInfoForm = ({ formData, errors, onChange, currentLanguage }) => {
  const content = {
    fr: {
      agencyName: 'Nom de l\'agence',
      agencyNamePlaceholder: 'Ex: Agence Al-Baraka Voyages',
      licenseNumber: 'Numéro de licence',
      licenseNumberPlaceholder: 'Ex: LIC-2024-001',
      city: 'Ville',
      cityPlaceholder: 'Sélectionnez votre ville',
      address: 'Adresse complète',
      addressPlaceholder: 'Rue, quartier, code postal',
      phone: 'Téléphone',
      phonePlaceholder: '+212 5XX-XXXXXX',
      email: 'Email professionnel',
      emailPlaceholder: 'contact@agence.ma',
      website: 'Site web (optionnel)',
      websitePlaceholder: 'https://www.agence.ma'
    },
    ar: {
      agencyName: 'اسم الوكالة',
      agencyNamePlaceholder: 'مثال: وكالة البركة للسفر',
      licenseNumber: 'رقم الترخيص',
      licenseNumberPlaceholder: 'مثال: LIC-2024-001',
      city: 'المدينة',
      cityPlaceholder: 'اختر مدينتك',
      address: 'العنوان الكامل',
      addressPlaceholder: 'الشارع، الحي، الرمز البريدي',
      phone: 'الهاتف',
      phonePlaceholder: '+212 5XX-XXXXXX',
      email: 'البريد الإلكتروني المهني',
      emailPlaceholder: 'contact@agence.ma',
      website: 'الموقع الإلكتروني (اختياري)',
      websitePlaceholder: 'https://www.agence.ma'
    }
  };

  const text = content?.[currentLanguage];

  const cityOptions = [
    { value: 'casablanca', label: currentLanguage === 'fr' ? 'Casablanca' : 'الدار البيضاء' },
    { value: 'rabat', label: currentLanguage === 'fr' ? 'Rabat' : 'الرباط' },
    { value: 'marrakech', label: currentLanguage === 'fr' ? 'Marrakech' : 'مراكش' },
    { value: 'fes', label: currentLanguage === 'fr' ? 'Fès' : 'فاس' },
    { value: 'tangier', label: currentLanguage === 'fr' ? 'Tanger' : 'طنجة' },
    { value: 'agadir', label: currentLanguage === 'fr' ? 'Agadir' : 'أكادير' },
    { value: 'meknes', label: currentLanguage === 'fr' ? 'Meknès' : 'مكناس' },
    { value: 'oujda', label: currentLanguage === 'fr' ? 'Oujda' : 'وجدة' }
  ];

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label={text?.agencyName}
          type="text"
          name="agencyName"
          placeholder={text?.agencyNamePlaceholder}
          value={formData?.agencyName}
          onChange={onChange}
          error={errors?.agencyName}
          required
        />

        <Input
          label={text?.licenseNumber}
          type="text"
          name="licenseNumber"
          placeholder={text?.licenseNumberPlaceholder}
          value={formData?.licenseNumber}
          onChange={onChange}
          error={errors?.licenseNumber}
          required
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Select
          label={text?.city}
          placeholder={text?.cityPlaceholder}
          options={cityOptions}
          value={formData?.city}
          onChange={(value) => onChange({ target: { name: 'city', value } })}
          error={errors?.city}
          required
        />

        <Input
          label={text?.phone}
          type="tel"
          name="phone"
          placeholder={text?.phonePlaceholder}
          value={formData?.phone}
          onChange={onChange}
          error={errors?.phone}
          required
        />
      </div>
      <Input
        label={text?.address}
        type="text"
        name="address"
        placeholder={text?.addressPlaceholder}
        value={formData?.address}
        onChange={onChange}
        error={errors?.address}
        required
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label={text?.email}
          type="email"
          name="email"
          placeholder={text?.emailPlaceholder}
          value={formData?.email}
          onChange={onChange}
          error={errors?.email}
          required
        />

        <Input
          label={text?.website}
          type="url"
          name="website"
          placeholder={text?.websitePlaceholder}
          value={formData?.website}
          onChange={onChange}
          error={errors?.website}
        />
      </div>
    </div>
  );
};

export default AgencyInfoForm;